class WTxtImgTimeline {
  constructor(container) {
    this.container = container;
    this.timeline = null;
    this.progress = null;
    this.steps = [];
    this.bullets = [];

    this.setupElements();
    this.bindEvents();
    this.init();
  }

  setupElements() {
    this.timeline = this.container.querySelector('.w-txt-img__timeline');
    this.timelineLine = this.container.querySelector('.w-txt-img__timeline-line');
    this.progress = this.container.querySelector('.w-txt-img__timeline-progress');
    this.steps = Array.from(this.container.querySelectorAll('.w-txt-img__step'));
    this.bullets = Array.from(this.container.querySelectorAll('.w-txt-img__bullet'));
  }

  bindEvents() {
    this.handleScroll = this.throttle(this.updateProgress.bind(this), 16);
    this.handleResize = this.debounce(this.calculateLineHeight.bind(this), 100);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });
  }

  init() {
    if (!this.timeline || !this.progress || this.steps.length === 0) return;
    this.calculateLineHeight();
    this.updateProgress();
  }

  calculateLineHeight() {
    if (this.bullets.length < 2 || !this.timelineLine) return;

    const firstBullet = this.bullets[0];
    const lastBullet = this.bullets[this.bullets.length - 1];
    const timelineRect = this.timeline.getBoundingClientRect();
    const firstRect = firstBullet.getBoundingClientRect();
    const lastRect = lastBullet.getBoundingClientRect();

    const lineHeight = (lastRect.top + lastRect.height / 2) - (firstRect.top + firstRect.height / 2);
    this.timelineLine.style.height = `${lineHeight}px`;
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  updateProgress() {
    if (!this.timeline || this.bullets.length === 0) return;

    const viewportHeight = window.innerHeight;
    const triggerPoint = viewportHeight * 0.6;

    const firstBullet = this.bullets[0];
    const lastBullet = this.bullets[this.bullets.length - 1];

    const firstBulletRect = firstBullet.getBoundingClientRect();
    const lastBulletRect = lastBullet.getBoundingClientRect();

    const firstBulletCenter = firstBulletRect.top + firstBulletRect.height / 2;
    const lastBulletCenter = lastBulletRect.top + lastBulletRect.height / 2;
    const totalDistance = lastBulletCenter - firstBulletCenter;

    let progressPercent = 0;

    if (firstBulletCenter <= triggerPoint) {
      const scrolledDistance = triggerPoint - firstBulletCenter;
      progressPercent = Math.min(Math.max((scrolledDistance / totalDistance) * 100, 0), 100);
    }

    if (this.progress) {
      this.progress.style.height = `${progressPercent}%`;
    }

    this.updateSteps(triggerPoint);
  }

  updateSteps(triggerPoint) {
    this.steps.forEach((step, index) => {
      const bullet = this.bullets[index];
      if (!bullet) return;

      const bulletRect = bullet.getBoundingClientRect();
      const bulletCenter = bulletRect.top + bulletRect.height / 2;
      const isActive = bulletCenter <= triggerPoint;

      if (isActive) {
        step.classList.add('is-active');
      } else {
        step.classList.remove('is-active');
      }
    });
  }

  throttle(func, limit) {
    let inThrottle;
    return function (...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  destroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="w-txt-img"]');
  sections.forEach((section) => {
    new WTxtImgTimeline(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-section-type="w-txt-img"]')) {
    new WTxtImgTimeline(event.target.querySelector('[data-section-type="w-txt-img"]'));
  }
});
